/**
 * Where somebody was going before the platform asked them to sign in or to register: a path of
 * this app, kept in `?next=` through the sign-in page, the registration and the first sign-in's
 * questions (Welcome), so an invited player lands on the session they were sent to.
 *
 * Only a path of this app is ever followed: never another host, never `//host`, never the API.
 */
export function localReturnPath(next: string | null | undefined): string | null {
  if (!next || !next.startsWith('/')) return null;
  return next.startsWith('//') || next.startsWith('/api/') ? null : next;
}

/** `?next=…` for a link that must carry the return path, or nothing. */
export function nextQuery(next: string | null | undefined, prefix = '?'): string {
  const path = localReturnPath(next);
  return path ? `${prefix}next=${encodeURIComponent(path)}` : '';
}
